import { render, staticRenderFns } from "./InvoicingOnOff.vue?vue&type=template&id=c1b0638e&scoped=true&"
import script from "./InvoicingOnOff.vue?vue&type=script&lang=js&"
export * from "./InvoicingOnOff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1b0638e",
  null
  
)

export default component.exports